<template>
  <a :href="urlpessoa">
    <PessoaImage :imagem="imagem"/>
    <div class="dados">
      <h5>{{ nome }}</h5>
      <h6>{{ cargo }}</h6>
    </div>
  </a>
</template>

<script>
import PessoaImage from "./PessoaImage.vue"

export default {
  name: "Pessoa",
  props:["nome","cargo","imagem","urlpessoa"],
  components:{
    PessoaImage
  }
}
</script>

<style scoped>
a{
  display: flex;
  flex: 1;
  background-color: #f4f4f4;
  margin-left: 2px;
  margin-right: -15px;
  box-shadow: 2px 4px 17px -8px #928888ba;
  border-radius: 5px;

}

a:hover {
  box-shadow: 2px 4px 17px -6px rgb(84, 83, 83);
  cursor: pointer;
}






@media (max-width: 1280px) {
  a{
    margin-right: 0;
    padding-right: 4px;
    padding-left: 4px;
  }
}

.dados{
  display: flex;
  flex: 2;
  flex-direction: column;
  margin-right: 15px;
  padding-top: 30px;
}

@media (max-width: 1280px) {
  .dados{
    padding-top: 20px;
    padding-bottom: 20px;
    margin-left: 25px;
  }
}

h5{
  font-family: 'Montserrat';
  color: #333333;
  line-height: 1.4;
  font-size: 15px;
}

h6{
  font-family: 'PT Sans Bold Italic';
  color: #333333;
  font-size: 16px;
}

@media (max-width: 767px) {

  h5,h6{
    font-size: 14px;
  }

  h5{
    margin-bottom: 0;
  }

  .dados{
    padding-top: 18px;
    padding-bottom: 18px;
  }
}

</style>